import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {Header} from 'shells/typography/header';

import styles from './setup-special-state.module.css';

type Props = {
    type: 'loading' | 'error';
};

export function SetupSpecialState(props: Props) {
    return (
        <div className={styles['setup-special-state']}>
            {props.type === 'loading' ? (
                <React.Fragment>
                    <Header>Digging up your settings…</Header>
                    <LoadingIcon fill={colors.offWhiteDk} size={64} />
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Header>Oh no! Something went wrong loading this page.</Header>
                    <img src='/include/images/dashboard/list-summary-error_2x.png' />
                </React.Fragment>
            )}
        </div>
    );
}
